import React from 'react'

import './pin.css'

interface PinProps {
  icon: React.ReactElement<any>
  backgroundColor?: string
  color?: string
}

export default function Pin({ backgroundColor = '#666', color = '#fff', icon }: PinProps) {
  return (
    <div className="pin-marker">
      <div className="pin-icon" style={{ backgroundColor, color, zIndex: 10 }}>
        {icon}
      </div>
      <div className="pin-arrow" />
    </div>
  )
}
